import { createContext } from 'react';
import { PartTypesAuthContextType } from 'context/PartTypes/types';

// Initialize the context with both searchConfig and index
export const PartTypesAuthContext = createContext<PartTypesAuthContextType>({
  client: null,
  index: null,
  setRefetchCount: () => {console.log('setRefetchCount')},
});
